<template>
  <el-card class="box-card2" style="width:50%;margin-left: 30%;">
    <h1>{{ title }}</h1>
    <h4 v-html="content"></h4>
  </el-card>
</template>

<script>
import Card2 from "../components/card2.vue";
import bus from "../assets/bus.js";

export default {
  name: "Box2",
  // props:{
  //   articlelist:Array,
  // },
  data() {
    return {
      content: "",
      title: ""
    };
  },
  components: {
    bus,
    Card2
  },
  watch: {
    $route: "getPath"
  },
  methods: {
    async getPath() {
      let id = this.$route.params.id;
      const res = await this.$http.get("/dingyang/show-edit-article/" + id);
      this.title = res.data.data[0].title;
      this.content = res.data.data[0].content;
    }
  },
  mounted() {
    bus.$on("content", content => {
      this.content = content;
    });
    bus.$on("title", title => {
      this.title = title;
    });
  }
};
</script>

<style>
h4 {
  font-size: 16px;
  font-weight: 500;
}
.box-card2 {
  margin: 0 auto;
  margin-top: 1%;
  height: 800px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/box2.vue